<template>
  <v-app id="inspire">
    <v-fade-transition mode="out-in">
      <centered-layout v-if="error && code == 404">
        <page-not-found></page-not-found>
      </centered-layout>

      <centered-layout v-else-if="loading">
        <v-progress-circular
          :width="10"
          :size="70"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </centered-layout>

      <component v-else :is="layout">
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </component>
    </v-fade-transition>
  </v-app>
</template>

<script>
import layouts from '@/layouts'
import { mapState } from 'vuex'
import PageNotFound from '@/views/errors/404'

export default {
  name: 'App',
  components: {
    ...layouts,
    PageNotFound
  },
  computed: {
    layout() {
      let layout = 'default'

      if (
        this.isLoggedIn &&
        this.$route.matched[0] &&
        this.$route.matched[0].meta.layout == 'frontend'
      ) {
        layout = this.currentUser.mode
      } else {
        layout = this.$route.matched[0]
          ? this.$route.matched[0].meta.layout || 'default'
          : 'default'
      }

      return `${layout}-layout`
    },
    ...mapState('errors', ['error', 'code']),
    ...mapState('auth', ['loading'])
  },
  watch: {
    '$vuetify.breakpoint.name': {
      immediate: true,
      handler(value) {
        this.$store.state.responsive.breakpoint = value
      }
    }
  }
}
</script>
